import { FileUploadTicketingProvider, TicketingEntityType } from '@neo.tax/shared/graphql';

interface TicketingProviderConfig {
  entityTypes: TicketingEntityType[];
  showFileDropZone: boolean;
  versionNumber?: number;
}

export const TICKETING_PROVIDER_CONFIG: Record<FileUploadTicketingProvider, TicketingProviderConfig> = {
  [FileUploadTicketingProvider.JiraCloud]: {
    entityTypes: [TicketingEntityType.Tickets, TicketingEntityType.Users],
    showFileDropZone: false,
    versionNumber: 2,
  },
  [FileUploadTicketingProvider.JiraDataCenter]: {
    entityTypes: [TicketingEntityType.Tickets, TicketingEntityType.Users],
    showFileDropZone: false,
    versionNumber: 2,
  },
  [FileUploadTicketingProvider.AzureDevops]: {
    entityTypes: [TicketingEntityType.Tickets],
    // ADO routes through OneSchema (like Jira/GitHub) so the required `hostId` column is mapped +
    // validated at upload. `false` makes the modal use the OneSchema flow
    // (onSubmitOneSchema → showOneSchema → OneSchemaModal).
    showFileDropZone: false,
    // Uses the AZURE_DEVOPS-TICKETS-V2 OneSchema template (adds the required `hostId` column). This
    // bump is the release-time switch — the modal requests `…-V2` when this ships. The V2 template
    // must exist in the OneSchema dashboard before deploy, or ADO web-app uploads will 404.
    versionNumber: 2,
  },
  [FileUploadTicketingProvider.Other]: {
    entityTypes: [
      TicketingEntityType.Tickets,
      TicketingEntityType.Users,
      TicketingEntityType.Collections,
      TicketingEntityType.Teams,
    ],
    showFileDropZone: true,
  },
  [FileUploadTicketingProvider.Asana]: {
    entityTypes: [
      TicketingEntityType.Tickets,
      TicketingEntityType.Users,
      TicketingEntityType.Collections,
      TicketingEntityType.Teams,
    ],
    showFileDropZone: true,
  },
  [FileUploadTicketingProvider.GithubIssues]: {
    entityTypes: [TicketingEntityType.Tickets, TicketingEntityType.Users, TicketingEntityType.Collections],
    showFileDropZone: false,
    // Requests the `-V2` OneSchema templates, which carry the required repo numeric id column
    // (Tickets: `Repository ID`, Collections: `ID`) that binds tickets to workstreams by repo id.
    // Applies to all three entity types, so a Users `-V2` template must exist (a copy of V1).
    versionNumber: 2,
  },
  [FileUploadTicketingProvider.Linear]: {
    entityTypes: [TicketingEntityType.Tickets, TicketingEntityType.Users, TicketingEntityType.Teams],
    showFileDropZone: true,
  },
  [FileUploadTicketingProvider.Shortcut]: {
    entityTypes: [TicketingEntityType.Tickets, TicketingEntityType.Users, TicketingEntityType.Collections],
    showFileDropZone: true,
  },
  [FileUploadTicketingProvider.Trello]: {
    entityTypes: [TicketingEntityType.Tickets, TicketingEntityType.Users, TicketingEntityType.Collections],
    showFileDropZone: true,
  },
};
